import { render, staticRenderFns } from "./Residencies.vue?vue&type=template&id=298a13f2&"
import script from "./Residencies.vue?vue&type=script&lang=js&"
export * from "./Residencies.vue?vue&type=script&lang=js&"
import style0 from "./Residencies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports